var drop_array = [];

drop_array['equipment-menu'] = `<h2 class="section-title">Pool Equipment <span class="shop-all-cat"><a href="/pages/swimming-pool-equipment">Shop All</a></span> <svg class="close-nav" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"></path>
</svg></h2>
<a href="#" class="shop-back">Go Back</a>
<div class="sub-nav-grid sub-nav-grid-five scrollable">
 <div>
<h3><a href="/pages/pool-automation" class="sub-section-head">Automation</a></h3>
<ul class="sub-section"><li><a href="/collections/equipment-controllers">Equipment Controllers</a></li><li><a href="/collections/chemical-monitoring">Chemical Controllers</a></li><li><a href="/collections/chemical-pumps">Chemical Pumps</a></li><li><a href="/collections/timers">Timers</a></li><li><a href="/collections/vfd-controllers">VFD Controllers</a></li><li><a href="/collections/water-level-controllers">Water Level Control</a></li></ul>
<h3><a href="/pages/handicap-pool-access" class="sub-section-head">ADA Pool Access</a></h3>
<ul class="sub-section"><li><a href="/collections/ada-pool-lift-chairs">Pool Lifts</a></li><li><a href="/collections/ada-spa-lift-chairs">Spa Lifts</a></li><li><a href="/collections/ada-stairs-and-ramps">Stairs &amp; Ramps</a></li><li><a href="/collections/wheelchairs">Wheelchairs</a></li><li><a href="/collections/pool-lift-batteries-and-chargers">Lift Batteries</a></li></ul>

<h3><a href="/pages/above-ground-equipment" class="sub-section-head">Above Ground Pools</a></h3>
<ul class="sub-section"><li><a href="/pages/above-ground-equipment">Shop Above Ground</a></li></ul>
<h3><a href="/pages/pool-cleaning" class="sub-section-head">Cleaning</a></h3>
<ul class="sub-section"><li><a href="/collections/manual-battery-pool-cleaners">Manual Battery Cleaners</a></li><li><a href="/collections/robotic-pool-cleaners">Robotic Pool Cleaners</a></a></li><li><a href="/collections/manual-electric-pool-cleaners">Manual Electric Pool Cleaners</a></li><li><a href="/collections/pool-brushes">Brushes</a></li><li><a href="/collections/pool-hoses">Hoses</a></li><li><a href="/collections/rakes-and-skimmers">Rakes &amp; Skimmers</a></li><li><a href="/collections/telescopic-and-straight-pool-poles">Telescopic Poles</a></li><li class="extra-nav" data-extra="cleaning"><a href="/collections/pressure-side-pool-cleaners">Pressure-Side Pool Cleaners</a></li><li class="extra-nav" data-extra="cleaning"><a href="/collections/suction-side-pool-cleaners">Suction-Side Cleaners</a></a></li><li class="extra-nav" data-extra="cleaning"><a href="/collections/vacuum-heads">Vacuum Heads</a></li><li><a href="#" class="view-more-nav" data-extra="cleaning">Show 3 more...</a></li></ul>
</div>
<div>
<h3><a href="/pages/filtration" class="sub-section-head">Filtration</a></h3>
<ul class="sub-section"><li><a href="/pages/filtration">Pool Filters</a></li><li><a href="/collections/hair-and-lint-strainers">Hair &amp; Lint Strainers</a></li><li><a href="/collections/filter-valves">Filter Valves</a></li><li><a href="/collections/filter-media">Filter Media</a></li><li><a href="/collections/filter-cartridges">Cartridges</a></li><li><a href="/collections/de-filter-grids">DE Filter Grids</a></li><li><a href="/collections/pressure-gauges">Pressure Gauges</a></li></ul>   
<h3><a href="/collections/pool-and-spa-heaters" class="sub-section-head">Heaters</a></h3>
<ul class="sub-section"><li><a href="/collections/natural-gas-pool-heaters">Natural Gas Heaters</a></li>
<li><a href="/collections/propane-pool-heaters">Propane Heaters</a></li>
<li><a href="/collections/electric-pool-heaters">Electric Heaters</a></li>
<li class="extra-nav" data-extra="heaters"><a href="/collections/pool-heat-pumps">Heat Pumps</a></li>
<li class="extra-nav" data-extra="heaters"><a href="/collections/pool-heat-exchangers">Heat Exchangers</a></li>
<li class="extra-nav" data-extra="heaters"><a href="/collections/hayward-heaters">Hayward Heaters</a></li>
<li class="extra-nav" data-extra="heaters"><a href="/collections/raypak-pool-heaters">Raypak Heaters</a></li>
<li><a href="#" class="view-more-nav" data-extra="heaters">Show 4 more...</a></li></ul>
<h3><a href="/pages/ladders-and-rails" class="sub-section-head">Ladders & Rails</a></h3>
<ul class="sub-section"><li><a href="/collections/anchor-wedges">Anchor Wedges</a></li>
<li><a href="/collections/deck-anchors">Deck Anchors</a></li>
<li><a href="/collections/escutcheons-and-ladder-bumpers">Escutcheons & Bumpers</a></li>
<li><a href="/collections/steps-and-treads">Steps & Treads</a></li>
<li><a href="/collections/ladders">Ladders</a></li>
<li><a href="/collections/deck-rails">Deck Rails</a></li>
<li><a href="/collections/stair-rails">Stair Rails</a></li>
<li><a href="/collections/exercise-rails">Exercise Rails</a></li>
<li><a href="/collections/figure-4-rails">Figure 4 Rails</a></li>
<li><a href="/collections/p-rails">P Rails</a></li>
<li><a href="/collections/pretzel-rails">Pretzel Rails</a></li>
<li><a href="/collections/ring-rails">Ring Rails</a></li></ul>
</div>
<div>
<h3><a href="/pages/pool-and-spa-lights" class="sub-section-head">Pool Lights</a></h3>
<ul class="sub-section"><li><a href="/collections/led-pool-lights">LED Pool Lights</a></li><li><a href="/collections/light-controllers">Light Controllers</a></li><li><a href="/collections/light-accessories">Light Accessories</a></li><li><a href="/collections/spa-lights">Spa Lights</a></li></ul>
<h3><a href="/pages/pool-covers" class="sub-section-head">Covers</a></h3> 
<ul class="sub-section"><li><a href="/collections/safety-pool-covers">Safety Covers</a></li> <li><a href="/collections/safety-cover-accessories">Safety Cover Accessories</a></li> <li><a href="/collections/winter-pool-covers">Winter Covers</a></li> <li><a href="/collections/equipment-covers">Equipment Covers</a></li> <li><a href="/collections/solar-pool-covers">Solar Pool Covers</a></li> <li><a href="/collections/thermal-spa-covers">Thermal Covers</a></li> <li><a href="/pages/custom-thermal-covers">Custom Thermal Covers</a></li> <li><a href="/collections/cover-pumps">Cover Pumps</a></li> <li><a href="/collections/solar-and-thermal-cover-reels">Solar + Thermal Reels</a></li> <li><a href="/collections/water-tubes-and-pillows">Water Tubes + Pillows</a></li></ul>
<h3><a href="/pages/pumps-blowers" class="sub-section-head">Pumps & Blowers</a></h3> 
<ul class="sub-section"><li><a href="/collections/spa-blowers">Blowers</a></li><li><a href="/collections/pool-pumps">Pool Pumps</a></li><li><a href="/collections/aeration-cannons">Aeration Cannons</a></li><li><a href="/collections/pump-motors">Pump Motors</a></li></ul>
<h3><a href="/pages/storage" class="sub-section-head">Pool Storage</a></h3>
<ul class="sub-section"><li><a href="/collections/racing-lane-storage">Racing Lane Storage</a></li><li><a href="/fitness-and-training-storage">Fitness & Training Storage</a></li><li><a href="/collections/maintenance-storage">Maintenance Storage</a></li><li class="extra-nav" data-extra="storage"><a href="/collections/storage-chests">Storage Chests</a></li><li class="extra-nav" data-extra="storage"><a href="/collections/pool-cover-storage">Pool Cover Storage</a></li><li class="extra-nav" data-extra="storage"><a href="/collections/timing-systems-storage">Timing Systems Storage</a></li><li class="extra-nav" data-extra="storage"><a href="/collections/solar-and-thermal-cover-reels">Solar & Thermal Cover Reels</a></li><li><a href="#" class="view-more-nav" data-extra="storage">Show 4 more...</a></li></ul>
</div>
<div>
<h3><a href="/pages/plumbing" class="sub-section-head">Plumbing</a></h3>
<ul class="sub-section"><li><a href="/collections/fittings">Fittings</a></li><li><a href="/collections/flanges-and-gaskets">Flanges &amp; Gaskets</a></li><li><a href="/collections/fill-spouts">Fill Spouts</a></li><li><a href="/collections/flow-meters">Flow Meters</a></li><li><a href="/collections/pipe-hangers">Pipe Hangers</a></li><li class="extra-nav" data-extra="plumbing"><a href="/collections/pipes-and-tubing">Pipes &amp; Tubing</a></li><li class="extra-nav" data-extra="plumbing"><a href="/collections/plumbing-supplies">Plumbing Supplies</a></li><li class="extra-nav" data-extra="plumbing"><a href="/collections/surge-tanks">Surge Tanks</a></li><li class="extra-nav" data-extra="plumbing"><a href="/pages/plumbing">Valves</a></li><li class="extra-nav" data-extra="plumbing"><a href="/collections/chemical-tank-labels">Chemical Tank Labels</a></li><li><a href="#" class="view-more-nav" data-extra="plumbing">Show 5 more...</a></li></ul>
<h3><a href="/pages/white-goods" class="sub-section-head">White Goods</a></h3>
<ul class="sub-section">
<li><a href="/collections/pool-gutter-grates">Gutter Grates</a></li>
<li><a href="/collections/main-drains">Main Drains</a></li>
<li><a href="/collections/pool-inlet-drains">Inlet Drains</a></li>
<li><a href="/collections/return-and-wall-fittings">Return & Wall Fittings</a></li>
<li><a href="/collections/skimmers">Skimmers</a></li>
<li><a href="/collections/skimmer-baskets">Skimmer Baskets</a></li>
<li><a href="/collections/skimmer-lids">Skimmer Lids</a></li>
<li><a href="/collections/thermometers-and-sensors">Thermometers</a></li>
<li class="extra-nav" data-extra="white-goods"><a href="/collections/vacuum-plates-and-hose-adapters">Vacuum Plates</a></li>
<li class="extra-nav" data-extra="white-goods"><a href="/collections/hydrotherapy-fittings">Hydrotherapy Fittings</a></li>
<li class="extra-nav" data-extra="white-goods"><a href="/collections/directional-flow-outlets">Directional Outlets</a></li>
<li class="extra-nav" data-extra="white-goods"><a href="/collections/skimmer-weirs">Weirs</a></li>
<li><a href="#" class="view-more-nav" data-extra="white-goods">Show 4 more...</a></li>
</ul>  
<h3><a href="/pages/pool-winterization" class="sub-section-head">Winterization</a></h3>
<ul class="sub-section"><li><a href="/collections/winterizing-chemicals">Winterizing Chemicals</a></li><li><a href="/collections/drain-and-skimmer-protection">Drain &amp; Skimmer Protection</a></li> <li><a href="/collections/winter-blowers">Winter Blowers</a></li> <li><a href="/collections/winter-plugs">Winter Plugs</a></li></ul>
</div>
<div>
<div class="stacked-images">
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-hammerhead.jpg?v=1764119289);background-position:bottom;">
<span class="nav-feature-title"><a href="/collections/hammerhead">Hammerhead Cleaners</a></span>
<a href="/collections/hammerhead" class="nav-feature-button">Shop Now</a>
</div>
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-pool-lifts.jpg?v=1765484158);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/collections/ada-pool-lift-chairs">ADA Pool Lifts</a></span>
<a href="/collections/ada-pool-lift-chairs" class="nav-feature-button">Shop Now</a>
</div>
</div>
</div>`;

drop_array['chemicals-menu'] = `<h2 class="section-title">Water Chemistry <span class="shop-all-cat"><a href="/pages/chemicals-testing">Shop All</a></span> <svg class="close-nav" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"></path>
</svg></h2>
<a href="#" class="shop-back">Go Back</a>
<div class="sub-nav-grid sub-nav-grid-four scrollable">
<div>
<h3><a href="/pages/pool-chemicals" class="sub-section-head">Pool Chemicals</a></h3>
<ul class="sub-section"><li><a href="/collections/algaecides">Algaecides</a></li><li><a href="/collections/enzymes">Enzymes</a></li><li><a href="/collections/alkalinity">Alkalinity</a></li> <li><a href="/collections/calcium">Calcium</a></li><li><a href="/collections/chlorine">Chlorine</li><li><a href="/collections/ph-balancers">pH</a></li> <li class="extra-nav" data-extra="chemicals"><a href="/collections/stabilizers-and-neutralizers">Stabilizers + Neutralizers</a></li> <li class="extra-nav" data-extra="chemicals"><a href="/collections/cleaning-chemicals">Cleaning Chemicals</a></li> <li class="extra-nav" data-extra="chemicals"><a href="/collections/specialty-chemicals">Specialty Chemicals</a></li> <li class="extra-nav" data-extra="chemicals"><a href="/collections/winterizing-chemicals">Winterizing Chemicals</a></li> <li class="extra-nav" data-extra="chemicals"><a href="/collections/safety-gear">Safety Gear</a></li><li><a href="#" class="view-more-nav" data-extra="chemicals">Show 5 more...</a></li> </ul>
</div>
<div>
<h3><a href="/pages/pool-automation" class="sub-section-head">Automation</a></h3>
<ul class="sub-section">
<li><a href="/collections/chemical-monitoring">Chemical Monitoring</a></li>
<li><a href="/collections/chemical-pumps">Chemical Pumps</a></li>
<li><a href="/collections/chemical-controller-probes">Chemical Probes</a></li>
<li><a href="/collections/chemical-tanks">Chemical Tanks</a></li>
<li><a href="/collections/chlorinators">Chlorinators</a></li>
<li><a href="/collections/chlorine-salt-generators">Chlorine Generators</a></li>
<li><a href="/collections/sanitization-systems">Sanitization Systems</a></li>
</ul>
</div>
<div>
<h3><a href="/pages/water-testing" class="sub-section-head">Water Testing</a></h3>
<ul class="sub-section"><li><a href="/pages/water-testing">Test Kits</a></li> <li><a href="/collections/test-strips">Test Strips</a></li> <li><a href="/collections/reagents">Reagents</a></li> <li><a href="/collections/cpo-log-books">CPO Log Books</a></li> </ul>
</div>
<div>
<div class="sub-nav-collapsible-images">
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/stenner-navigation-tile.jpg?v=1782998246);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/collections/stenner-chemical-pumps">Stenner Pumps</a></span>
<a href="/collections/stenner-chemical-pumps" class="nav-feature-button">Shop Now</a>
</div>
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-cat.jpg?v=1764118850);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/pages/hayward-pool-supplies">CAT Controllers</a></span>
<a href="/pages/hayward-pool-supplies" class="nav-feature-button">Shop Now</a>
</div>
</div>
</div>
</div>`;

drop_array['safety-menu'] = `<h2 class="section-title">Safety & Lifeguard <span class="shop-all-cat"><a href="/pages/safety-and-lifeguard">Shop All</a></span> <svg class="close-nav" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"></path>
</svg></h2>
<a href="#" class="shop-back">Go Back</a>
<div class="sub-nav-grid sub-nav-grid-four scrollable">
<div>
<h3><a href="/pages/first-aid" class="sub-section-head">First Aid</a></h3>
<ul class="sub-section"><li><a href="/collections/first-aid-kits">First Aid Kits</a></li> <li><a href="/collections/aed-units">AED Units</a></li> <li><a href="/collections/cpr-masks">CPR Masks</a></li> <li><a href="/collections/first-aid-kit-contents">First Aid Kit Contents</a></li> <li><a href="/collections/accessories">Accessories</a></li> <li><a href="/collections/bedding">Bedding</a></li></ul>
<h3><a href="/pages/first-response" class="sub-section-head">First Response</a></h3>
<ul class="sub-section"><li><a href="/collections/spineboards">Spineboards</a></li> <li><a href="/collections/life-hooks">Life Hooks</a></li> <li><a href="/collections/life-rings">Life Rings</a></li> <li><a href="/collections/rescue-boards-and-kayaks">Rescue Boards</a></li> <li><a href="/collections/throw-lines">Throw Lines</a></li> </ul>
</div>
<div>
<h3><a href="/pages/lifeguard-equipment" class="sub-section-head">Lifeguard Equipment</a></h3>
<ul class="sub-section"><li><a href="/collections/lifeguard-chairs">Lifeguard Chairs</a></li><li><a href="/collections/training-aids">Lifeguard Training Aids</a></li><li><a href="/collections/megaphones">Megaphones</a></li><li><a href="/collections/whistles">Whistles</a></li><li><a href="/collections/rescue-cans">Rescue Cans</a></li><li><a href="/collections/rescue-tubes">Rescue Tubes</a></li></ul>
<h3><a href="/pages/safety-equipment" class="sub-section-head">Safety Equipment</a></h3>
<ul class="sub-section"><li><a href="/collections/pool-alarms">Pool Alarms</a></li><li><a href="/collections/emergency-telephones">Emergency Telephones</a></li>
<li><a href="/collections/vacuum-release-systems">VRS Systems</a></li><li><a href="/collections/floor-safety">Floor Safety</a></li><li class="extra-nav" data-extra="safety-equipment"><a href="/collections/gate-latches">Gate Latches</a></li><li class="extra-nav" data-extra="safety-equipment"><a href="/collections/beach-flags">Beach Flags</a></li><li class="extra-nav" data-extra="safety-equipment"><a href="/collections/diaper-changing-stations">Diaper Changing Stations</a></li><li><a href="#" class="view-more-nav" data-extra="safety-equipment">Show 3 more...</a></li></ul>
</div>
<div>
<h3><a href="/pages/pool-rope-and-floats" class="sub-section-head">Rope & Floats</a></h3>
<ul class="sub-section"><li><a href="/collections/pool-safety-rope-and-floats">Rope & Float Kits</a></li><li><a href="/collections/pool-rope">Pool Rope</a></li><li><a href="/collections/rope-floats">Rope Floats</a></li><li><a href="/collections/regulatory-buoys">Regulatory Buoys</a></li><li><a href="/collections/eyebolts">Eyebolts</a></li><li><a href="/collections/rope-anchors">Rope Anchors</a></li><li><a href="/collections/rope-hooks">Rope Hooks</a></li></ul>
</div>
<div class="sub-nav-collapsible-images">
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-lifering-buoys.jpg?v=1765484971);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/collections/life-rings">Shop Life Rings</a></span>
<a href="/collections/life-rings" class="nav-feature-button">Shop Now</a>
</div>
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-first-aid-kits.jpg?v=1765484981);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/collections/first-aid-kits">First Aid Kits</a></span>
<a href="/collections/first-aid-kits" class="nav-feature-button">Shop Now</a>
</div>
</div>`;

drop_array['signs-menu'] = `<h2 class="section-title">Pool Signs <span class="shop-all-cat"><a href="/pages/pool-signs">Shop All</a></span> <svg class="close-nav" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"></path>
</svg></h2>
<a href="#" class="shop-back">Go Back</a>
<div class="sub-nav-grid sub-nav-grid-four scrollable">
<div>
<h3><a href="/pages/pool-signs" class="sub-section-head">Pool Signs</a></h3>
<ul class="sub-section"> <li><a href="/pages/state-pool-regulations">Shop by State</a></li> <li><a href="/collections/beach-signs">Beach Signs</a></li> <li><a href="/collections/custom-signs">Custom Signs</a></li> <li><a href="/collections/capacity-signs">Capacity Signs</a></li> <li><a href="/collections/directional-signs">Directional Signs</a></li> <li><a href="/collections/first-aid-signs">First Aid Signs</a></li> <li><a href="/collections/lifeguard-signs">Lifeguard Signs</a></li> <li><a href="/collections/locker-room-signs">Locker Room Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/miscellaneous-rules-signs">Miscellaneous Rules Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/no-diving-signs">No Diving Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/no-swimming-signs">No Swimming Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/pool-chemical-signs">Pool Chemical Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/pool-informational-signs">Pool Informational Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/pool-open-and-closed-signs">Open + Closed Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/pool-policy-signs">Pool Policy Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/pool-rules-signs">Pool Rules Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/safety-notification-signs">Safety Notification Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/spa-rules-signs">Spa Rules Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/swim-lane-signs">Swim Lane Signs</a></li> <li class="extra-nav" data-extra="signs"><a href="/collections/telephone-signs">Telephone Signs</a></li><li><a href="#" class="view-more-nav" data-extra="signs">Show 12 more...</a></li></ul>
</div>
<div>
<h3><a href="/pages/depth-markers" class="sub-section-head">Depth Markers</a></h3>
<ul class="sub-section"> <li><a href="/collections/3m-stick-on-depth-markers">3M Stick-On</a></li> <li><a href="/collections/skid-resistant-ceramic-depth-markers">Skid Resistant Ceramic</a></li> <li><a href="/collections/smooth-ceramic-depth-markers">Smooth Ceramic</a></li> <li><a href="/collections/plastic-overlay-depth-markers">Plastic Overlay</a></li> <li><a href="/collections/reusable-stencil-depth-markers">Reusable Stencil</a></li> <li><a href="/collections/single-use-stencil-depth-markers">Single Use Stencil</a></li> </ul>
</div>
<div>
<h3><a href="/collections/chemical-tank-labels">Labels</a></h3>
<ul class="sub-section"><li><a href="/collections/chemical-tank-labels">Chemical Labels</a></li></ul>
</div>
<div>
<div class="sub-nav-collapsible-images">
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-shop-by-state.jpg?v=1765392493);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/pages/pool-signs">State Compliant Signs</a></span>
<a href="/pages/pool-signs" class="nav-feature-button">Shop Now</a>
</div>
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-depth-markers_73da0556-373f-403b-a537-26877790546d.jpg?v=1765508269);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/pages/depth-markers">Depth Markers</a></span>
<a href="/pages/depth-markers" class="nav-feature-button">Shop Now</a>
</div>
</div>
</div>`;

drop_array['competitive-menu'] = `<h2 class="section-title">Competitive Swim <span class="shop-all-cat"><a href="/pages/competitive-swim">Shop All</a></span> <svg class="close-nav" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"></path>
</svg></h2>
<a href="#" class="shop-back">Go Back</a>
<div class="sub-nav-grid sub-nav-grid-two scrollable">
<div>
<h3><a href="/pages/competitive-swim" class="sub-section-head">Swim Racing Equipment</a></h3>
<ul class="sub-section multi-column-sub-section  always-show"><li><a href="/collections/racing-lanes">Racing Lanes</a></li> <li><a href="/collections/starting-blocks">Starting Blocks</a></li> <li><a href="/collections/backstroke-flags">Backstroke Flags</a></li> <li><a href="/collections/scoreboards">Scoreboards</a></li> <li><a href="/collections/pace-clocks">Pace Clocks</a></li> <li><a href="/collections/timing-equipment">Timing Equipment</a></li> <li><a href="/collections/stanchion-posts">Stanchion Posts</a></li> <li><a href="/collections/swim-meet-aids">Swim Meet Aids</a></li></ul>
</div>
<div>
<div class="sub-nav-collapsible-images">
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-custom-backstroke.jpg?v=1765391982);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/pages/custom-backstroke-flag-quote">Custom Backstroke Flags</a></span>
<a href="/pages/custom-backstroke-flag-quote" class="nav-feature-button">Shop Now</a>
</div>
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-starting-blocks-a.jpg?v=1765386555);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/collections/starting-blocks">Starting Blocks</a></span>
<a href="/collections/starting-blocks" class="nav-feature-button">Shop Now</a>
</div>
</div>
</div>`;


drop_array['fun-and-rec-menu'] = `<h2 class="section-title">Recreation & Fun <span class="shop-all-cat"><a href="/pages/fun-recreation">Shop All</a></span> <svg class="close-nav" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"></path>
</svg></h2>
<a href="#" class="shop-back">Go Back</a>
<div class="sub-nav-grid sub-nav-grid-four scrollable">
<div>
<h3><a href="/pages/water-sports" class="sub-section-head">Water Sports</a></h3>
<ul class="sub-section"><li><a href="/collections/basketball-pool-games">Basketball</a></li> <li><a href="/collections/volleyball-pool-games">Volleyball</a></li> <li><a href="/collections/water-polo-pool-games">Water Polo</a></li> <li><a href="/pages/diving-boards-and-stands">Diving Boards</a></li><li><a href="/collections/pool-climbing-walls">Climbing Walls</a></li><li><a href="/collections/water-slides">Water Slides</a></li> <li><a href="/collections/balls">Balls</a></li> </ul>
<h3><a href="/pages/fitness" class="sub-section-head">Fitness & Aerobics</a></h3>
<ul class="sub-section"><li><a href="/collections/stretching-and-resistance">Stretching + Resistance</a></li> <li><a href="/collections/water-aerobics">Water Aerobics</a></li> </ul>
</div>
<div>
<h3><a href="/pages/swim-training" class="sub-section-head">Swim Training</a></h3>
<ul class="sub-section"><li><a href="/collections/swim-training">Swim Training Hardware</a></li> <li><a href="/collections/lifejackets">Lifejackets</a></li> <li><a href="/collections/kickboards">Kickboards</a></li> <li><a href="/collections/noodles">Noodles</a></li> </ul>
<h3><a href="/pages/swim-gear" class="sub-section-head">Swim Gear</a></h3>
<ul class="sub-section"><li><a href="/collections/fins">Fins</a></li> <li><a href="/collections/floats-and-tubes">Floats + Tubes</a></li> <li><a href="/collections/lifejackets">Lifejackets</a></li> <li><a href="/collections/masks-and-snorkels">Masks + Snorkels</a></li> <li><a href="/collections/backpacks">Backpacks</a></li></ul>
</div>
<div>
<h3><a href="/pages/pool-furniture" class="sub-section-head">Furniture</a></h3>
<ul class="sub-section"><li><a href="/collections/chairs">Chairs</a></li> <li><a href="/collections/lounges">Lounges</a></li> <li><a href="/collections/tables">Tables</a></li> <li><a href="/collections/umbrellas">Umbrellas</a></li> </ul>
</div>
<div>
<div class="sub-nav-collapsible-images">
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-basketball.jpg?v=1765482414);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/collections/basketball-pool-games">Basketball Games</a></span>
<a href="/collections/basketball-pool-games" class="nav-feature-button">Shop Now</a>
</div>
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-patio-furniture.jpg?v=1765482133);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/pages/pool-furniture">Patio Furniture</a></span>
<a href="/pages/pool-furniture" class="nav-feature-button">Shop Now</a>
</div>
</div>
</div>`;

drop_array['parts-menu'] = `<h2 class="section-title">Parts & Repair <span class="shop-all-cat"><a href="/pages/parts">Shop All</a></span> <svg class="close-nav" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"></path>
</svg></h2>
<a href="#" class="shop-back">Go Back</a>
<div class="sub-nav-grid sub-nav-grid-four scrollable">
<div>
<h3><a href="/pages/parts" class="sub-section-head">Parts Diagrams</a></h3>
<ul class="sub-section">
<li><a href="/pages/aeration-cannon-parts">Aeration Cannons</a></li>
<li><a href="/pages/blower-parts">Blowers</a></li>
<li><a href="/pages/chemical-controller-parts">Chemical Controllers</a></li>
<li><a href="/pages/chemical-feeder-pump-parts">Chemical Feeder Pumps</a></li>
<li><a href="/pages/chlorinator-parts">Chlorinators</a></li>
<li><a href="/pages/chlorine-generator-parts">Chlorine Generators</a></li>
<li><a href="/pages/pool-cleaner-parts">Pool Cleaners</a></li>
<li><a href="/pages/diving-board-parts">Diving Boards</a></li>
<li><a href="/pages/equipment-controller-parts">Equipment Controllers</a></li>
<li><a href="/pages/filter-parts">Filters</a></li>
<li><a href="/pages/flow-meter-parts">Flow Meters</a></li>
<li><a href="/pages/heat-pump-parts">Heat Pumps</a></li>
<li><a href="/pages/heater-parts">Heaters</a></li>
<li><a href="/pages/lighting-parts">Pool Lights</a></li>
<li><a href="/pages/main-drain-parts">Main Drains</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/lifeguard-chair-parts">Lifeguard Chairs</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/maintenance-equipment-parts">Maintenance Equipment</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/pool-game-parts">Pool Games</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/pool-lift-parts">Pool Lifts</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/pump-parts">Pumps</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/racing-lane-parts">Racing Lanes</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/skimmer-parts">Skimmers</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/starting-block-parts">Starting Blocks</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/storage-reel-parts">Storage Reels</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/strainer-parts">Strainers</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/test-kit-parts">Test Kits</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/timing-system-parts">Timing Systems</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/vacuum-release-parts">VRS Systems</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/valve-parts">Valves</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/water-feature-parts">Water Features</a></li>
<li class="extra-nav" data-extra="diagrams"><a href="/pages/water-filler-parts">Water Fillers</a></li>
<li><a href="#" class="view-more-nav" data-extra="diagrams">Show 17 more...</a></li>
</ul>
</div>
<div>
<h3><a href="/pages/parts" class="sub-section-head">Commonly Replaced</a></h3>
<ul class="sub-section">
<li><a href="/collections/anchor-wedges">Anchor Wedges</a></li>
<li><a href="/collections/chemical-controller-probes">Chemical Controller Probes</a></li>
<li><a href="/collections/chemical-feeder-tubes">Chemical Feeder Tubes</a></li>
<li><a href="/collections/deck-anchors">Deck Anchors</a></li>
<li><a href="/collections//diving-board-bolt-kits">Diving Board Bolts</a></li>
<li><a href="/collections/escutcheons-and-ladder-bumpers">Escutcheons & Ladder Bumpers</a></li>
<li><a href="/collections/game-replacement-parts">Game Replacement Parts</a></li>
<li><a href="/collections/ladder-bolts">Ladder Bolts</a></li>
<li><a href="/collections/pool-tools">Pool Tools</a></li>
<li><a href="/collections/pool-cleaner-filter-bags">Pool Cleaner Filters</a></li>
<li><a href="/collections/pool-lift-batteries-and-chargers">Pool Lift Batteries</a></li>
<li><a href="/collections/pump-motors">Pump Motors</a></li>
<li><a href="/collections/steps-and-treads">Steps & Treads</a></li>
<li><a href="/collections/strainer-baskets">Strainer Baskets</a></li>
</ul>
</div>
<div>
<h3><a href="/pages/paint-and-patch" class="sub-section-head">Paint & Patch</a></h3>
<ul class="sub-section"><li><a href="/collections/pool-and-deck-patching">Surface Patching</a></li> <li><a href="/pages/pool-paint">Pool Paint</a></li> <li><a href="/collections/primer">Primer</a></li> <li><a href="/collections/anti-slip-coating">Anti-Slip Coating</a></li> <li><a href="/collections/crack-and-joint-repair">Crack + Joint Repair</a></li> <li><a href="/collections/additives-and-accessories">Additives &amp; Accessories</a></li> </ul> 
</div>
<div>
<div class="sub-nav-collapsible-images">
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-all-parts.jpg?v=1766618939);background-position:bottom;background-size:cover !important;">
<span class="nav-feature-title"><a href="/pages/parts">All Parts & Repair</a></span>
<a href="/pages/parts" class="nav-feature-button">Shop Now</a>
</div>
<div class="desk-only nav-feature-image" style="background-image:url(https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-paint-patch.jpg?v=1766520609);background-position:bottom;background-size:auto !important;">
<span class="nav-feature-title"><a href="/pages/paint-and-patch">Paint & Patch</a></span>
<a href="/pages/paint-and-patch" class="nav-feature-button">Shop Now</a>
</div>
</div>
</div>`;

jQuery(document).ready(function ($) {
  jQuery(document).on("focusin", "body.nav-modal-open", function (e) {
    var $target = $(e.target);
    if (!$target.closest(".nav-modal").length) {
      $("#close-nav").focus();
    }
  });

  jQuery(document).on("keyup", "body.nav-modal-open", function (e) {
    if (e.type === "keyup" && e.key !== "Escape") {
      return;
    }
    closeNavigation();
  });

  $(".toggle-navigation").on("click", function () {
    $(".nav-modal").toggleClass("nav-open");
    $(".nav-flyout").removeClass("slide-in");
    $("body").toggleClass("nav-popped");
    if ($("body").hasClass("nav-modal-open")) {
      $("#main-nav-pop").attr("aria-expanded", "true");
    } else {
      $("#main-nav-pop").attr("aria-expanded", "false");
    }
    setTimeout(function () {
      $("#shop-all-departments").focus();
    }, 200);
  });


  $(document).on('click','.close-nav,.close-section', function(){
    closeNavigation();
  });

  $("#overlay,.close-modal").on("click", function () {
    closeNavigation();
  });

  function toggleNavigation(clicked_section_id) {

  }

  function closeNavigation() {
    $(".nav-modal").removeClass("nav-open");
    $("#overlay").removeClass("overlay-open");
    $(".nav-pop").removeClass("active");
    $(".nav-flyout").removeClass("slide-in");
    $("body").removeClass("nav-popped");
    $(".primary-nav-top-with-subs").removeClass('active-button');
  }

  $(document).on('click','.shop-back', function(){
    $(".primary-nav-top").removeClass("active-button");
    $(".nav-flyout").removeClass("slide-in");
  });




  $(".primary-nav-top-with-subs").on("click", function(e) {
      e.preventDefault();
      var clicked_section_id = $(this).attr('id');
      var which_menu = $('[data-drop-id='+clicked_section_id+']');

      $(".nav-flyout").removeClass('slide-in');
      $(".primary-nav-top-with-subs").not(this).removeClass('active-button');

      if($(this).hasClass("active-button")) {
        console.log('you clicked an active button');
        $(this).removeClass("active-button");
        $(".nav-flyout").removeClass('slide-in');
        $("body").removeClass("nav-popped");
        $(".view-more-nav").show();
        $(".extra-nav").hide();
      }
      else {
        $(this).addClass('active-button');
        $("body").addClass("nav-popped");
        $(".nav-flyout").html(drop_array[clicked_section_id]);

        $(".nav-flyout").addClass("slide-in");


      }
  });


 
  
  $("body").on("click", ".sub-section-head", function (e) {
    e.preventDefault();
    var width = $(window).width();
    $(this).toggleClass("expanded");
    if (width <= 1024) {
      var the_list = $(this).parent().next();
      the_list.slideToggle();
    } else {
      clicked_url = $(this).attr("href");
      window.location.href = clicked_url;
    }
  });

  

  $("#support-drop").click(function (e) {
    e.preventDefault();
    $("body").toggleClass("help-pop-open");

    if ($("body").hasClass("help-pop-open")) {
      $("#support-drop").attr("aria-expanded", "true");
      $(".help-drop").show();
    } else {
      $("#support-drop").attr("aria-expanded", "false");
      $(".help-drop").hide();
    }

    
  });

  jQuery(document).on("focusin", "body.help-pop-open", function (e) {
    var $target = $(e.target);
    if (!$target.closest(".help-drop").length) {
      $("#close-help-drop").focus();
    }
  });
 
  $(document).mouseup((e) => {
    const $menu = $(".help-drop");
    if (
      !$menu.is(e.target) && // if the target of the click isn't the container...
      $menu.has(e.target).length === 0
    ) {
      // ... nor a descendant of the container
      $menu.hide();
      $("body").removeClass("help-pop-open");
    }
  });

      $(document).mouseup((e) => {
      const $menu = $(".nav-flyout");
      if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && !e.target.classList.contains('drop')) {
        $(".primary-nav-top").removeClass("active-button");
        $(".nav-flyout").removeClass("slide-in");
      }
    });
    
  $(".close-support-drop").click(function (e) {
    e.preventDefault();
    $(".help-drop").toggle();
    $("body").removeClass("help-pop-open");
    $("#support-drop").attr("aria-expanded", "false");
  });

  $(".mobile-search-trigger").click(function (e) {
    e.preventDefault();
    $(".boost-pfs-search-suggestion-mobile-overlay").show();
    $(".boost-pfs-search-suggestion-mobile-top-panel").show();
    $("#boost-pfs-search-box-mobile").focus();
  });

  $(".why-poolweb-pop").click(function (e) {
    console.log('made you click');
  });

  $(".foot-section h2").click(function () {
    var menu = $(this).next(".footer-links");
    menu.slideToggle();
  });

  $("body").on("click", ".view-more-nav", function (e) {
      e.preventDefault();
      var which_to_expand = $(this).data("extra");
      $(".extra-nav[data-extra="+which_to_expand+"]").slideDown(75);
      $(this).hide();
  });

  $("body").on("click", ".why-poolweb-pop", function (e) {
    html_to_load = $(this).data('html');
    $('#why-poolweb-modal-content').html("<p style='text-align:center;padding:40px;margin:0'>&nbsp;</p>"); 
     $.ajax({
        url: '/?section_id='+html_to_load,
        type: 'GET',
        dataType: 'html',
        success: function(data) {
          $('#why-poolweb-modal-content').html(data); 
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching snippet content:", errorThrown);
        }
      });
  });



  $.preloadImages = function() {
    for (var i = 0; i < arguments.length; i++) {
      $("<img />").attr("src", arguments[i]);
    }
  }

  $.preloadImages("https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-hammerhead.jpg?v=1764119289","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/stenner-navigation-tile.jpg?v=1782998246","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-cat.jpg?v=1764118850","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-depth-markers_73da0556-373f-403b-a537-26877790546d.jpg?v=1765508269","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-starting-blocks-a.jpg?v=1765386555","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-custom-backstroke.jpg?v=1765391982","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-shop-by-state.jpg?v=1765392493","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-patio-furniture.jpg?v=1765482133","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-basketball.jpg?v=1765482414","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-pool-lifts.jpg?v=1765484158","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-lifering-buoys.jpg?v=1765484971","https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-first-aid-kits.jpg?v=1765484981", "https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-all-parts.jpg?v=1766618939", "https://cdn.shopify.com/s/files/1/0331/2857/9210/files/sub-nav-bg-paint-patch.jpg?v=1766520609");
});
